import type { ApiVolopImportedType } from '#/modules/listing/volops/api/types/ApiVolopImportedType';

export const VOLOP_IMPORTED_TYPE_MAP: Record<ApiVolopImportedType, string> = {
  POINTS_OF_LIGHT: 'Points of Light',
  AARP: 'AARP',
  DO_SOMETHING: 'DoSomething',
  TRANSFORMA: 'Transforma',
  GOLDEN: 'Golden',
};
